/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_Ask_Questions_SuccessInputs */

const es_tools_nexata_ask_questions_success = /** @type {(inputs: Tools_Nexata_Ask_Questions_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas generadas`)
};

const en_tools_nexata_ask_questions_success = /** @type {(inputs: Tools_Nexata_Ask_Questions_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions generated`)
};

/**
* | output |
* | --- |
* | "Questions generated" |
*
* @param {Tools_Nexata_Ask_Questions_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_ask_questions_success = /** @type {((inputs?: Tools_Nexata_Ask_Questions_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_Ask_Questions_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_ask_questions_success(inputs)
	return en_tools_nexata_ask_questions_success(inputs)
});
export { tools_nexata_ask_questions_success as "tools.nexata.ask_questions_success" }